import React from "react";
import { useSector } from "./SectorContext";

const Menu = () => {
  const { activeSector, setSector, changeSector } = useSector();
  return (
    <>
      <div className="header-menu">
        <div className="header-menu-wrapper">
          <div className="header-menu-list">
            <div
              className={`header-menu-item cyber-menu ${
                activeSector.colorClass === "cyber-accent" ? "active-menu" : ""
              }`}
              onClick={() => changeSector("cyber")}
            >
            Cybersecurity
            </div>

            <div
              className={`header-menu-item advert-menu ${
                activeSector.colorClass === "advert-accent" ? "active-menu" : ""
              }`}
              onClick={() => changeSector("advertising")}
            >
              Advertising
            </div>
            {/* <div
              className={`header-menu-item web-menu ${
                activeSector.colorClass === "web-accent" ? "active-menu" : ""
              }`}
              onClick={() => changeSector("web")}
            >
              Web Development
            </div>
             */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;
